import { useTranslation } from 'react-i18next'

import { ProfileCreatedWidget } from '../../../../Widget'
import { QA_NAME_LISTING_PROFILE_WIDGET_CREATED } from '../RentalPortalListingProfile.constants'
import { useListingProfileContext } from '../RentalPortalListingProfile.hooks'
import { toListingProfileUserValue } from '../RentalPortalListingProfile.utils'

function RentalPortalListingProfileWidgetCreated() {
  const { t } = useTranslation()

  const { isInitiated, listingData } = useListingProfileContext()

  return (
    <ProfileCreatedWidget
      contentProps={{
        createdAt: listingData?.created,
        createdBy: toListingProfileUserValue(listingData?.created_by),
      }}
      isSkeleton={!isInitiated || !listingData}
      title={t('Widget.CreatedTitleKey')}
      widgetProps={{ qaName: QA_NAME_LISTING_PROFILE_WIDGET_CREATED }}
    />
  )
}

export default RentalPortalListingProfileWidgetCreated
